import { jsx } from 'react/jsx-runtime';
import { cx } from 'class-variance-authority';

const NavigationList = ({ children, className, ...props }) => {
    return (jsx("ul", { className: cx("mci-flex mci-flex-1 mci-flex-col mci-gap-xxs mci-overflow-y-auto mci-px-s", className), ...props, children: children }));
};

export { NavigationList };
